<template>
<div>
    <!-- ============================================================== -->
    <!-- Left Sidebar - style you can find in sidebar.scss  -->
    <!-- ============================================================== -->
    <aside class="left-sidebar">
        <!-- Sidebar scroll-->
        <div class="scroll-sidebar">
            <!-- Sidebar navigation-->
            <nav class="sidebar-nav">
                <ul id="sidebarnav" v-if="isAuthenticated">
                    <li v-permissions="'core.customerrelations.read'">
                        <a class="has-arrow waves-effect waves-dark" href="#" aria-expanded="false">
                            <i class="mdi mdi-city"></i>
                            <span class="hide-menu">Manager</span>
                        </a>
                        <ul aria-expanded="false" class="collapse">
                            <li v-permissions="'core.customerrelations.read'">
                                <router-link :to="{ name: 'customer-relations:index' }" class="waves-effect waves-dark" aria-expanded="false">{{$t('sidebar.klantrelaties')}}</router-link>
                            </li>
                        </ul>
                    </li>
                    <li v-permissions="'comceptum.workorders.read'">
                        <a class="has-arrow waves-effect waves-dark" href="#" aria-expanded="false">
                            <i class="mdi mdi-format-list-bulleted"></i>
                            <span class="hide-menu">Orders</span>
                        </a>
                        <ul aria-expanded="false" class="collapse">
                            <li v-permissions="'comceptum.workorders.read'">
                                <router-link :to="{ name: 'workorders:index' }" class="waves-effect waves-dark" aria-expanded="false">{{$t('sidebar.overzicht')}}</router-link>
                            </li>
                            <li v-permissions="'comceptum.workorders.read'">
                                <router-link :to="{ name: 'export-times:index' }" class="waves-effect waves-dark" aria-expanded="false">{{$t('sidebar.urenexport')}}</router-link>
                            </li>
                        </ul>
                    </li>
                    <li v-permissions="'carpetline.orders.read|carpetline.usercustomerrelations.read'">
                        <a class="has-arrow waves-effect waves-dark" href="#" aria-expanded="false">
                            <i class="mdi mdi-format-list-bulleted"></i>
                            <span class="hide-menu">Order portal</span>
                        </a>
                        <ul aria-expanded="false" class="collapse">
                            <li v-permissions="'carpetline.orders.read'">
                                <router-link :to="{ name: 'orders:index' }" class="waves-effect waves-dark" aria-expanded="false">Orders</router-link>
                            </li>
                            <li v-permissions="'carpetline.usercustomerrelations.read.company|carpetline.usercustomerrelations.read.system'">
                                <router-link :to="{ name: 'user-customer-relations:index' }" class="waves-effect waves-dark" aria-expanded="false">{{$t('sidebar.gebruikers')}}</router-link>
                            </li>
                        </ul>
                    </li>
                    <li v-permissions="'besimple.deprecated.read'">
                        <a class="has-arrow waves-effect waves-dark" href="#" aria-expanded="false">
                            <i class="mdi mdi-file-document"></i>
                            <span class="hide-menu">FM Beheer</span>
                        </a>
                        <ul aria-expanded="false" class="collapse">
                            <li v-permissions="'fm.releases.update'">
                                <router-link :to="{ name: 'releases:index' }" class="waves-effect waves-dark" aria-expanded="false">{{$t('sidebar.releasesbeheren')}}</router-link>
                            </li>
                            <li v-permissions="'fm.customers.read'">
                                <router-link :to="{ name: 'customers:index' }" class="waves-effect waves-dark" aria-expanded="false">
                                    {{$t('sidebar.klanten')}}
                                </router-link>
                            </li>
                            <li v-permissions="'fm.priceagreements.read'">
                                <router-link :to="{ name: 'price-agreements:index' }" class="waves-effect waves-dark" aria-expanded="false">
                                    {{$t('sidebar.prijsafspraken')}}
                                </router-link>
                            </li>
                            <li v-permissions="'fm.report.read'">
                                <router-link :to="{ name: 'report:index' }" class="waves-effect waves-dark" aria-expanded="false">
                                    {{$t('sidebar.rapportage')}}
                                </router-link>
                            </li>
                             <li v-permissions="'fmmodule.invoicerecognitiondata.read.user'">
                                <router-link :to="{ name: 'invoicerecognitiondata:index' }" class="waves-effect waves-dark" aria-expanded="false">
                                    {{$t('sidebar.factuurherkenning')}}
                                </router-link>
                            </li>
                             <li v-permissions="'fmmanagement.documents.read.user'">
                                <router-link :to="{ name: 'documents:index' }" class="waves-effect waves-dark" aria-expanded="false">
                                    {{$t('sidebar.onbekendedocumenten')}}
                                </router-link>
                            </li>
                        </ul>
                    </li>
                    <li v-permissions="'besimple.deprecated.read'">
                        <a class="has-arrow waves-effect waves-dark" href="#" aria-expanded="false">
                            <i class="mdi mdi-lock-outline"></i>
                            <span class="hide-menu">{{$t('sidebar.beheren')}}</span>
                        </a>
                        <ul aria-expanded="false" class="collapse">
                            <li v-permissions="'core.companies.read.system'">
                                <router-link :to="{ name: 'companies:index' }" class="waves-effect waves-dark" aria-expanded="false">{{$t('sidebar.bedrijven')}}</router-link>
                            </li>
                            <li v-permissions="'core.groups.read.system'">
                                <router-link :to="{ name: 'groups:index' }" class="waves-effect waves-dark" aria-expanded="false">{{$t('sidebar.groepen')}}</router-link>
                            </li>
                            <li v-permissions="'core.modules.read.system'">
                                <router-link :to="{ name: 'modules:index' }" class="waves-effect waves-dark" aria-expanded="false">{{$t('sidebar.modules')}}</router-link>
                            </li>
                        </ul>
                    </li>
                    <li id="fmmodule_main_menu" v-permissions="'fmmodule.invoices.read.company'">
                        <a id="fmmodule_main_menu_arrow" class="has-arrow waves-effect waves-dark" href="#" aria-expanded="false">
                            <i class="mdi icon-fmmodule-logo-1"></i>
                            <span class="hide-menu">{{$t('sidebar.fmweb')}}</span>
                        </a>
                        <ul id="fmmodule_main_menu_index" aria-expanded="false" class="collapse">
                            <li>
                                <router-link id='fmmodule_main_menu_index_routerlink' :to="{ name: 'invoices:index' }" class="waves-effect waves-dark" aria-expanded="false">{{$t('sidebar.facturen')}}</router-link>
                            </li>
                        </ul>
                    </li>                    
                </ul>
            </nav>
            <!-- End Sidebar navigation -->
        </div>
        <!-- End Sidebar scroll-->
    </aside>
    <!-- ============================================================== -->
    <!-- End Left Sidebar - style you can find in sidebar.scss  -->
    <!-- ============================================================== -->
</div>
</template>

<script>
import $ from "jquery";
import { productInfo } from '@/mixins/productInfo'

require('@/../public/js/sidebarmenu');

export default {
    mixins: [productInfo],	
    name: "SideBar",
    methods: {
        async handleLoginEvent(data) {
            this.isAuthenticated = data.loggedIn;
            this.profile = data.profile;

            if (this.isAuthenticated) {
                await this.$nextTick();
                $("#sidebarnav").AdminMenu();
            }
        },
        activateFMModuleMenuItem() {
            $("#fmmodule_main_menu").toggleClass("active", true);
            $("#fmmodule_main_menu_arrow").css('aria-expanded','true');
            $("#fmmodule_main_menu_index").css('aria-expanded','true');
            $("#fmmodule_main_menu_index").toggleClass("collapse in", true);
            $("#fmmodule_main_menu_index_routerlink").toggleClass("active", true);
            $("#fmmodule_main_menu_index_routerlink").css('aria-expanded','true');
        }
    },
    watch:{
        $route (to){
            if (this.isFMModule() && (to.path === "/" || to.path === "/fmmodule/invoices" || to.path === "/fmmodule/invoices/"))
            {
                this.activateFMModuleMenuItem();        
            }
        }
    },    
    data() {
        return {
            isAuthenticated: false,
            profile: {}
        };
    }
};
</script>
